import * as turf from './turf';

export const featureCollectionToTurfPolygons = (featureCollection, homeMarkerGeoJson = null) => {
    const turfPolygons = [];
    featureCollection.features.forEach(feature => {
        // Validera att feature har geometry
        if (!feature || !feature.geometry) {
            console.warn('[featureCollectionToTurfPolygons] Skipping feature without geometry:', feature);
            return;
        }
        
        // Validera att geometry har type
        if (!feature.geometry.type) {
            console.warn('[featureCollectionToTurfPolygons] Skipping feature without geometry.type:', feature);
            return;
        }
        
        let polygon;
        try {
            if (feature.geometry.type === 'GeometryCollection') {
                if (!feature.geometry.geometries || !Array.isArray(feature.geometry.geometries)) {
                    console.warn('[featureCollectionToTurfPolygons] Skipping GeometryCollection without geometries array:', feature);
                    return;
                }
                polygon = turf.multiPolygon(feature.geometry.geometries.map(g => g.coordinates));
            } else if (feature.geometry.type === 'MultiPolygon') {
                if (!feature.geometry.coordinates || !Array.isArray(feature.geometry.coordinates)) {
                    console.warn('[featureCollectionToTurfPolygons] Skipping MultiPolygon without coordinates:', feature);
                    return;
                }
                polygon = turf.multiPolygon(feature.geometry.coordinates);
            } else {
                if (!feature.geometry.coordinates || !Array.isArray(feature.geometry.coordinates)) {
                    console.warn('[featureCollectionToTurfPolygons] Skipping Polygon without coordinates:', feature);
                    return;
                }
                polygon = turf.polygon(feature.geometry.coordinates);
            }
        } catch (error) {
            console.warn('[featureCollectionToTurfPolygons] Error creating polygon for feature:', feature.properties?.name || 'unknown', error);
            return;
        }
        
        turfPolygons.push({
            polygon,
            feature: {
                ...feature,
                properties: {
                    homeMarkerGeoJson,
                    ...feature.properties,
                    area: turf.area(polygon)
                }
            }
        });
    });

    return turfPolygons;
};